import { create } from 'zustand'

type AppState = {
  readonly sidebarOpen: boolean
  readonly toggleSidebar: () => void
  readonly setSidebarOpen: (open: boolean) => void
}

export const useAppStore = create<AppState>((set) => ({
  sidebarOpen: true,
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
}))
